export const FREE_FALL_DELAY_LOGIC_PROVIDER_TOKEN = Symbol('FREE_FALL_DELAY_LOGIC_PROVIDER_TOKEN');

export interface IFreeFallDelayLogicProvider {
  getReelFallDelay(): number[];
}
